import { atom } from "jotai";
import { observe } from "jotai-effect";

import type { DisplayEvent } from "@/lib/event-helpers";

import { currentUserIdAtom } from "@/atoms/session";
import { fetchAllEvents } from "@/lib/event-queries";

export const eventsAtom = atom<DisplayEvent[]>([]);
export const eventsLoadingAtom = atom(true);

observe((get, set) => {
  get(currentUserIdAtom);
  set(eventsLoadingAtom, true);
  fetchAllEvents()
    .then((events) => set(eventsAtom, events))
    .finally(() => set(eventsLoadingAtom, false));
});
